import {AutocompleteOption, Bubble, IBubble, Graph, Section, Area, GraphTab, Villages, Village} from "./interface";
import { GraphNameValues, GraphName } from "../api/generated/api-types";
import { ChartSettings } from "./chart-models";

export type FormatName = 'currency' | 'percentage' | 'people' | null;
export namespace FormatNameValues {
    export const CURRENCY: FormatName = 'currency';
    export const PERCENTAGE: FormatName = 'percentage';
    export const PEOPLE: FormatName = 'people';
    export const NULL: FormatName = null;
}

// areas data
export const AreasData: Area[] = [
    {
        name: 'Viimsi vald',
        value: 'viimsi'
    }
];
export const VillageData: Villages = {
    viimsi: [
        { name: 'Haabneeme alevik', value: 'Haabneeme' },
        { name: 'Idaotsa küla', value: 'Idaotsa' },
        { name: 'Kelnase küla', value: 'Kelnase' },
        { name: 'Kelvingi küla', value: 'Kelvingi' },
        { name: 'Laiaküla', value: 'Laiaküla' },
        { name: 'Leppneeme küla', value: 'Leppneeme' },
        { name: 'Lubja küla', value: 'Lubja' },
        { name: 'Lääneotsa küla', value: 'Lääneotsa' },
        { name: 'Metsakasti küla', value: 'Metsakasti' },
        { name: 'Miiduranna küla', value: 'Miiduranna' },
        { name: 'Muuga küla', value: 'Muuga' },
        { name: 'Randvere küla', value: 'Randvere' },
        { name: 'Rohuneeme küla', value: 'Rohuneeme' },
        { name: 'Pringi küla', value: 'Pringi' },
        { name: 'Pärnamäe küla', value: 'Pärnamäe' },
        { name: 'Püünsi küla', value: 'Püünsi' },
        { name: 'Tammneeme küla', value: 'Tammneeme' },
        { name: 'Viimsi alevik', value: 'Viimsi' },
        { name: 'Viimsi vald', value: 'Viimsi vald' },
        { name: 'Viimsi vald kokku', value: 'kokku' },
        { name: 'Äigrumäe küla', value: 'Äigrumäe' },
        { name: 'Mujal', value: 'Mujal' }
    ]
}

// section data
export const SectionData: Section[] = [
    {
        name: "Tulude üldine laekumine",
        title: "Tulude üldine laekumine",
        description: "Eelarve täitmine eelnenud kuu seisuga.",
        value: "tulud",
        defaultGraphName: "tulubaas"
    },
    {
        name: "Tulude laekumine ajas",
        title: "Tulude laekumine ajas",
        description: "",
        value: "tulud-ajas",
        defaultGraphName: "tulude-laekumine-ajas"
    },
    {
        name: "Tööhõive",
        title: "Brutosissetulek",
        value: "toohoive",
        defaultGraphName: "toohoive",
        tabs: [
            {
                title: 'Brutosissetulek',
                description: 'Inimeste arv või osakaal töötasu vahemikes',
                value: 'toohoive'
            },
            {
                title: 'Töötamise asukoht',
                description: '',
                value: 'toohoive-asukoht'
            },
            {
                title: 'Viimsilaste töökohad',
                description: '',
                value: 'toohoive-top'
            },
            {
                title: 'Viimsilaste töövaldkonnad',
                description: '',
                value: 'toohoive-emtak'
            }
        ]
    },
    {
        name: "Tulud palgagrupiti",
        title: "Tulud tööandja asukoha põhiselt",
        description: "Töötamise asukoha põhised andmed on kättesaadavad alates 2017. a.",
        value: "tulud-palgagrupiti",
        defaultGraphName: "tulude-laekumine-vanuseruhmiti"
    },
    {
        name: "Võimalikud tuluallikad",
        title: "Võimalikud tuluallikad",
        value: "tulude-potentsiaal",
        defaultGraphName: "tulude-potentsiaalne-laekumine",
        tabs: [
            {
                title: 'Dividenditulu',
                graphTitle: 'Viimsi elanikele makstud dividendid*',
                description: '*Vastavalt seadusele laekub tulumaks väljamakstud dividendidelt vaid riigieelarvesse, mitte kohaliku omavalitsuse tulubaasi',
                value: 'tulude-potentsiaalne-laekumine'},
            {
                title: 'Tulubaasi kasv, kui dividenditulust laekuks 2% maksutulu KOV-i',
                description: '',
                value: 'tulude-potentsiaalne-laekumine-kasv',},
            {
                title: 'FIT maksutulu suurenemise kalkulaator',
                graphTitle: 'FIT* maksutulu suurenemise kalkulaator',
                description: 'Mängi läbi valla tulubaasi suurenemine. Mitu maksumaksjat aastas valda lisandub? Mitu protsenti suureneb viimsilaste töötasu? *FIT on füüsilise isiku tulumaks.',
                value: 'fit'}
        ]
    },
    {
        name: "Maamaksu laekumise prognoos",
        title: "Maamaksu laekumise prognoos",
        value: "maamaks",
        defaultGraphName: "maamaksu-laekumine"
    },
    {
        name: "Demograafilised andmed",
        title: "Demograafilised andmed",
        description: "Demograafilised andmed",
        value: "demograafilised",
        defaultGraphName: "demograafilised-andmed-vanus",
        tabs: [
            // {
            //     title: 'Inimeste arvu muutus ajas',
            //     value: 'demograafilised-andmed'
            // },
            {
                title: 'Inimeste arv vanuserühmade kaupa',
                value: 'demograafilised-andmed-vanus'
            },
            {
                title: 'Sisse/välja registreerimised',
                value: 'demograafilised-andmed-registreeritud'
            }
        ]
    },
    {
        name: "Elanike tulude jaotus",
        title: "Elanike tulude jaotus",
        description: "Elanike tulude jaotus",
        value: "tulude-jaotus",
        defaultGraphName: "tulude-jaotus-summa",
        tabs: [
            {
                title: 'Piirkonna elanike aastatulud',
                value: 'tulude-jaotus-summa'
            },
            {
                title: 'Piirkonna maksumaksjate arv',
                value: 'tulude-jaotus-arv'
            }
        ]
    }
]

// Chart settings
export const getGraphSettings = (graphName?: string): ChartSettings => {
    let settings: ChartSettings;
    switch (graphName) {
        case 'tulubaas':
            settings = {
                title: 'Tulude üldine laekumine',
                description: '',
                stacked: true,
                uiConfig: {
                    format: true,
                    graphSelector: [
                        {
                            label: 'Suurimad tuluartiklid',
                            value: 'tulubaas',
                        },
                        {
                            label: 'Maksutulud',
                            value: 'maksutulud'
                        }
                    ]
                },
                x: {
                    label: 'aasta'
                },
                y: {
                    graphName: GraphNameValues.ÜLDINE_TULUDE_LAEKUMINE,
                    label: 'täitmineKassapõhine',
                    group: 'tüüp',
                    format: [FormatNameValues.CURRENCY, FormatNameValues.PERCENTAGE]
                }
            }
            break;
        case 'maksutulud':
            settings = {
                title: 'Tulude üldine laekumine',
                description: '',
                stacked: true,
                uiConfig: {
                    format: true,
                    graphSelector: [
                        {
                            label: 'Suurimad tuluartiklid',
                            value: 'tulubaas',
                        },
                        {
                            label: 'Maksutulud',
                            value: 'maksutulud'
                        }
                    ]
                },
                x: {
                    label: 'aasta'
                },
                y: {
                    graphName: GraphNameValues.ÜLDINE_TULUDE_LAEKUMINE,
                    label: 'täitmineKassapõhine',
                    group: 'nimi',
                    format: [FormatNameValues.CURRENCY, FormatNameValues.PERCENTAGE]
                }
            }
            break;
        case 'tulude-laekumine-ajas':
            settings = {
                title: 'Tulude laekumine ajas',
                description: '',
                stacked: true,
                uiConfig: {
                    graphSelector: [
                        {
                            label: 'Brutosissetulek',
                            value: 'tulude-laekumine-ajas',
                        },
                        {
                            label: 'Maksutulud',
                            value: 'tulude-laekumine-ajas-tax'
                        }
                    ]
                },
                x: {
                    label: 'aasta'
                },
                y: {
                    graphName: GraphNameValues.TULUDE_LAEKUMISE_SUMMA,
                    label: 'grupisIsikuid',
                    group: 'vanus',
                    format: FormatNameValues.PEOPLE
                },
                y2: [
                    {
                        graphName: GraphNameValues.TULUDE_LAEKUMISE_SUMMA,
                        label: 'keskmineBrutotulu',
                        renameLabel: 'Keskmine aasta bruto töötasu',
                        format: FormatNameValues.CURRENCY
                    }
                ]
            };
            break;
        case 'tulude-laekumine-ajas-tax':
            settings = {
                title: 'Tulude laekumine ajas',
                description: 'Enim on viie aastaga lisandunud 40-49 aastaseid, kes on ka suurimad maksumaksjad.',
                stacked: true,
                uiConfig: {
                    graphSelector: [
                        {
                            label: 'Brutosissetulek',
                            value: 'tulude-laekumine-ajas',
                        },
                        {
                            label: 'Maksutulud',
                            value: 'tulude-laekumine-ajas-tax'
                        }
                    ]
                },
                x: {
                    label: 'aasta'
                },
                y: {
                    graphName: GraphNameValues.TULUDE_LAEKUMISE_SUMMA,
                    label: 'grupisIsikuid',
                    group: 'vanus',
                    format: FormatNameValues.PEOPLE
                },
                y2: [
                    {
                        graphName: GraphNameValues.TULUDE_LAEKUMISE_SUMMA,
                        label: 'brutotulust116',
                        renameLabel: 'Vallale laekuv aastane tulumaks',
                        format: FormatNameValues.CURRENCY
                    }
                ]
            };
            break;
        case 'toohoive':
            settings = {
                title: 'Brutosissetulek',
                description: '',
                stacked: true,
                uiConfig: {
                    gender: true,
                    format: true
                },
                x: {
                    label: 'aasta'
                },
                y: {
                    graphName: GraphNameValues.ÜLDISELT_TÖÖTAVAD_INIMESED,
                    label: 'grupisIsikuid',
                    group: 'tulugrupp',
                    format: [FormatNameValues.PEOPLE, FormatNameValues.PERCENTAGE]
                },
                // y2: [
                //     {
                //         graphName: GraphNameValues.ÜLDISELT_TÖÖTAVAD_INIMESED,
                //         label: 'kokkuBrutotulud',
                //         renameLabel: 'Brutotulud kokku',
                //         group: undefined,
                //         format: FormatNameValues.CURRENCY
                //     }
                // ]
            }
            break;
        case 'toohoive-asukoht':
            settings = {
                title: 'Töötamise asukoht',
                description: '',
                uiConfig: {
                    format: true,
                    customCheck: [
                        {
                            label: 'Viimsi vallas ja muljal',
                            value: 'Viimsi vallas ja muljal'
                        },
                        {
                            label: 'Viimsi vald',
                            value: 'Viimsi vald'
                        },
                        {
                            label: 'Mujal',
                            value: 'Mujal'
                        }
                    ]
                },
                x: {
                    label: 'aasta'
                },
                y: {
                    graphName: GraphNameValues.TÖÖTAMISE_ASUKOHT,
                    label: 'erinevaidTootajaid',
                    group: 'asukohaGrupp',
                    format: [FormatNameValues.PEOPLE, FormatNameValues.PERCENTAGE]
                }
            };
            break;
        case 'toohoive-top':
            settings = {
                title: 'Viimsilaste töökohad',
                description: '',
                stacked: true,
                uiConfig: {},
                x: {
                    label: 'aasta'
                },
                y: {
                    graphName: GraphNameValues.TOP10_ASUKOHA_PÕHINE,
                    label: 'hõivatudIsikuid',
                    group: 'linnVald',
                    format: FormatNameValues.PERCENTAGE
                }
            };
            break;
        case 'toohoive-emtak':
            settings = {
                title: 'Viimsilaste töövaldkonnad',
                description: '',
                stacked: true,
                uiConfig: {},
                x: {
                    label: 'aasta'
                },
                y: {
                    graphName: GraphNameValues.EMTAK2_PÕHINE,
                    label: 'hõivatudIsikuid',
                    group: 'sektorMkr',
                    format: FormatNameValues.PERCENTAGE,
                    limit: 5
                }
            };
            break;
        case 'tulude-laekumine-palgagrupiti':
            settings = {
                title: 'Tulud tööandja asukoha põhiselt',
                description: 'Töötamise asukoha põhised andmed on kättesaadavad alates 2017. a. Viimati uuendatud: 30.11.2017.',
                stacked: true,
                uiConfig: {
                    gender: true,
                    graphSelector: [
                        {
                            label: 'Vanus',
                            value: 'tulude-laekumine-vanuseruhmiti'
                        },
                        {
                            label: 'Tööandja asukoht',
                            value: 'tulude-laekumine-palgagrupiti'
                        }
                    ],
                    customRadio: [
                        {
                            label: 'Viimsi vald ja mujal',
                            value: 'Viimsi vald ja mujal'
                        },
                        {
                            label: 'Viimsi vald',
                            value: 'Viimsi vald'
                        },
                        {
                            label: 'Mujal',
                            value: 'Mujal'
                        }
                    ]
                },
                x: {
                    label: 'aasta'
                },
                y: {
                    graphName: GraphNameValues.TULUDE_LAEKUMINE_PALGAGRUPITI,
                    label: 'brutotuludKokku', // dynamically set by filteredData :: mujalBrutotuludKokku | viimsiValdBrutotuludKokku | viimsiValdJaMujalBrutotuludKokku
                    group: 'tulugrupp',
                    format: FormatNameValues.CURRENCY
                }
            };
            break;
        case 'tulude-laekumine-vanuseruhmiti':
            settings = {
                title: 'Tulude laekumine vanuserühmiti',
                description: '',
                stacked: true,
                uiConfig: {
                    gender: true,
                    graphSelector: [
                        {
                            label: 'Vanus',
                            value: 'tulude-laekumine-vanuseruhmiti'
                        },
                        {
                            label: 'Tööandja asukoht',
                            value: 'tulude-laekumine-palgagrupiti'
                        }
                    ]
                },
                x: {
                    label: 'aasta'
                },
                y: {
                    graphName: GraphNameValues.TULUDE_LAEKUMINE_VANUSERÜHMITI,
                    label: 'brutotulust116',
                    group: 'vanus',
                    format: FormatNameValues.CURRENCY
                }
            };
            break;
        case 'tulude-potentsiaalne-laekumine':
            settings = {
                title: 'Viimsi elanikele makstud dividendid*',
                description: '*Vastavalt seadusele laekub tulumaks väljamakstud dividendidelt vaid riigieelarvesse, mitte kohaliku omavalitsuse tulubaasi',
                uiConfig: {},
                x: {
                    label: 'aasta'
                },
                y: {
                    graphName: GraphNameValues.DIVIDENDI_TULU_ÜLDISELT,
                    label: 'dividendideSumma',
                    renameLabel: 'Dividendide summa',
                    format: FormatNameValues.CURRENCY
                },
                y2: [
                    {
                        graphName: GraphNameValues.DIVIDENDI_TULU_SAAJAID_ARVULISELT,
                        label: 'erinevaidFüüsilisiIsikuid',
                        group: 'sugu',
                        format: FormatNameValues.PEOPLE
                    }
                ]
            };
            break;
        case 'tulude-potentsiaalne-laekumine-kasv':
            settings = {
                title: 'Tulubaasi kasv, kui dividenditulust laekuks 2% maksutulu KOV-i',
                description: '',
                uiConfig: {
                    gender: true
                },
                x: {
                    label: 'aasta'
                },
                y: {
                    graphName: GraphNameValues.TULUBAASI_KASV,
                    label: 'tulubaasiKasv',
                    group: 'vanus',
                    format: FormatNameValues.CURRENCY
                }
            }
            break;
        case 'maamaksu-laekumine':
            settings = {
                title: 'Maamaksu laekumise prognoos sihtotstarbe põhiselt',
                description: '',
                uiConfig: {
                    format: true,
                    graphSelector: [
                        {
                            label: 'Otstarve',
                            value: 'maamaksu-laekumine'
                        },
                        {
                            label: 'Asukoht',
                            value: 'maamaksu-laekumine-asukoht'
                        }
                    ]
                },
                x: {
                    label: 'aasta'
                },
                y: {
                    graphName: GraphNameValues.MAAMAKSU_LAEKUMINE_SIHTOTSTARBE_ALUSEL,
                    label: 'maamaks',
                    group: 'sihtotstarve',
                    format: [FormatNameValues.CURRENCY, FormatNameValues.PERCENTAGE],
                    limit: 3
                }
            };
            break;
        case 'maamaksu-laekumine-asukoht':
            settings = {
                title: 'Maamaksu laekumise prognoos asukoha põhiselt',
                description: '',
                uiConfig: {
                    format: true,
                    graphSelector: [
                        {
                            label: 'Otstarve',
                            value: 'maamaksu-laekumine'
                        },
                        {
                            label: 'Asukoha',
                            value: 'maamaksu-laekumine-asukoht'
                        }
                    ]
                },
                x: {
                    label: 'aasta'
                },
                y: {
                    graphName: GraphNameValues.MAAMAKSU_LAEKUMINE_ASUKOHA_ALUSEL,
                    label: 'maamaks',
                    group: 'nimi',
                    format: [FormatNameValues.CURRENCY, FormatNameValues.PERCENTAGE],
                    limit: 3
                }
            };
            break;
        case 'demograafilised-andmed':
            settings = {
                title: 'Inimeste arvu muutus ajas',
                description: '',
                uiConfig: {
                    gender: true
                },
                x: {
                    label: 'seisuAasta'
                },
                y: {
                    graphName: GraphNameValues.INIMESTE_ARVU_MUUTUS_AJAS,
                    label: 'elanike',
                    renameLabel: 'Elanike',
                    format: FormatNameValues.PEOPLE
                }
            };
            break;
        case 'demograafilised-andmed-vanus':
            settings = {
                title: 'Inimeste arv vanuserühmade kaupa',
                description: '',
                uiConfig: {
                    gender: true
                },
                x: {
                    label: 'seisuAasta'
                },
                y: {
                    graphName: GraphNameValues.INIMESED_VANUSERÜHMITI,
                    label: 'suguVanusegrupisKokku',
                    group: 'vanuseGrupp',
                    format: FormatNameValues.PEOPLE
                }
            };
            break;
        case 'demograafilised-andmed-registreeritud':
            settings = {
                title: 'Sisse/välja registreerimised',
                description: '',
                uiConfig: {
                    customRadio: [
                        {
                            label: 'Viimsisse registreerunud',
                            value: 'uuedRegistreerunudInimesed'
                        },
                        {
                            label: 'Viimsist lahkunud',
                            value: 'väljaRegistreerunud'
                        }
                    ],
                    customCheck: [
                        {
                            label: 'Sündinud Viimsis',
                            value: 'uutestRegistreerunutestSündinudVv'
                        },
                        {
                            label: 'Mujalt tulnud',
                            value: 'uutestRegistreerunutestVäljastTulnud'
                        }
                    ]
                },
                x: {
                    label: 'seisuAasta'
                },
                y: {
                    graphName: GraphNameValues.SISSE_VÄLJA_REGISTREERIMISED,
                    label: 'inimesed', // dynamically set by filteredData :: uuedRegistreerunudInimesed | uutestRegistreerunutestSündinudVv | uutestRegistreerunutestVäljastTulnud | väljaRegistreerunud
                    renameLabel: 'Isikuid',
                    format: FormatNameValues.PEOPLE
                }
            };
            break;
        case 'tulude-jaotus-summa':
            settings = {
                title: 'Piirkonna elanike palga- ja dividenditulud',
                description: '',
                stacked: true,
                uiConfig: {
                    customCheck: [
                        {
                            label: 'Pot. dividenditulud',
                            value: 'Pot. dividenditulud'
                        }
                    ]
                },
                x: {
                    label: 'aasta'
                },
                y: {
                    graphName: GraphNameValues.TULU_SUMMA_KÜLADE_KAUPA,
                    label: 'summa',
                    group: 'type',
                    format: FormatNameValues.CURRENCY
                },
                y2: [
                    {
                        graphName: GraphNameValues.TULU_SUMMA_KÜLADE_KAUPA,
                        label: 'palgatulu1116',
                        renameLabel: 'Valda laekuv tulumaks',
                        format: FormatNameValues.CURRENCY
                    },
                    {
                        graphName: GraphNameValues.TULU_SUMMA_KÜLADE_KAUPA,
                        label: 'dividenditulu2',
                        renameLabel: 'Pot. valda laekuv dividenditulu 2%',
                        format: FormatNameValues.CURRENCY
                    }
                ]
            };
            break;
        case 'tulude-jaotus-arv':
            settings = {
                title: 'Inimeste arv',
                description: '',
                stacked: true,
                uiConfig: {
                    customCheck: [
                        {
                            label: 'Pot. dividenditulud',
                            value: 'Pot. dividenditulud'
                        }
                    ]
                },
                x: {
                    label: 'aasta'
                },
                y: {
                    graphName: GraphNameValues.TULU_SUMMA_KÜLADE_KAUPA,
                    label: 'summa',
                    group: 'type',
                    format: FormatNameValues.PEOPLE
                },
                y2: [
                    {
                        graphName: GraphNameValues.TULU_SUMMA_KÜLADE_KAUPA,
                        label: 'palgatulu1116',
                        renameLabel: 'Valda laekuv tulumaks',
                        format: FormatNameValues.CURRENCY
                    },
                    {
                        graphName: GraphNameValues.TULU_SUMMA_KÜLADE_KAUPA,
                        label: 'dividenditulu2',
                        renameLabel: 'Valda laekuv potentsiaalne dividenditulu',
                        format: FormatNameValues.CURRENCY
                    }
                ]
            };
            break;
        case 'fit':
            settings = {
                title: '',
                description: '',
                uiConfig: {
                    gender: false,
                    format: false,
                    customCheck: [
                        {
                            label: 'Pot. dividenditulud',
                            value: 'Pot. dividenditulud'
                        }
                    ]
                },
                x: {
                    label: 'year'
                },
                y: {
                    graphName: GraphNameValues.TULUDE_LAEKUMISE_SUMMA, // DIVIDENDI_TULU_ÜLDISELT
                    label: 'tax',
                    group: 'type',
                    format: FormatNameValues.CURRENCY,
                }
            }
            break;
        default:
            settings = {
                title: '',
                description: '',
                uiConfig: {
                    customCheck: [
                        {
                            label: 'Pot. dividenditulud',
                            value: 'Pot. dividenditulud'
                        }
                    ]
                },
                x: {
                    label: ''
                },
                y: {
                    graphName: GraphNameValues.ÜLDINE_TULUDE_LAEKUMINE,
                    label: '',
                    format: null
                }
            };
            break;
    }
    return settings;
}

// bubble data for landing page
export const BubblesData: IBubble[] = [
    {
        priority: 1,
        size: 'xl',
        url: '/graphs/viimsi/kokku/tulud/tulubaas',
        contents: [
            {
                id: 'tulubaas',
                text: 'Viimsi tulud eelarves',
                value: null
            }
        ]
    },
    {
        priority: 2,
        size: 'lg',
        url: '/graphs/viimsi/kokku/tulud-ajas/tulude-laekumine-ajas',
        contents: [
            {
                id: 'füüsiliseIsikuTulumaks',
                text: 'Füüsilise isiku tulumaks',
                value: null
            }
        ]
    },
    {
        priority: 3,
        size: 'xs-alt',
        url: '/graphs/viimsi/kokku/demograafilised/demograafilised-andmed-vanus',
        contents: [
            {
                id: 'maksumaksjaid',
                text: 'maksumaksjat',
                value: null
            },
            {
                id: 'elanikeArv',
                text: 'elanikku',
                value: null
            }
        ]
    },
    {
        priority: 4,
        size: 'sm',
        url: '/graphs/viimsi/kokku/toohoive/toohoive',
        contents: [
            {
                id: null,
                text: 'Viimsi inimeste sissetulekud',
                value: '€'
            }
        ]
    },
    {
        priority: 5,
        size: 'md',
        url: '/graphs/viimsi/kokku/tulud-ajas/tulude-laekumine-ajas',
        contents: [
            {
                id: 'viimsiKeskmineBrutosissetulek',
                text: 'Töötavate viimsilaste keskmine brutotöötasu',
                value: null
            }
        ]
    },
    {
        priority: 6,
        size: 'xs',
        url: '/graphs/viimsi/kokku/tulude-potentsiaal/tulude-potentsiaalne-laekumine',
        contents: [
            {
                id: 'potensiaalneDividendiTulumaks',
                text: 'Võimalikud tuluallikad',
                value: null
            }
        ]
    }
]

// Graph Selectors (for radioboxes)
export const AgeGroups = [
    {label: 'kuni 18', name: 'kuni 18'},
    {label: '18-29', name: '18-29'},
    {label: '30-39', name: '30-39'},
    {label: '40-49', name: '40-49'},
    {label: '50-59', name: '50-59'},
    {label: '60-69', name: '60-69'},
    {label: '70+', name: '70+'},
]
export const viewMode = [
    {label: 'arvuline', value: 'sum'},
    {label: 'Protsentuaalne', value: 'ratio'}
]



// WEBPACK FOOTER //
// ./src/core/localData.ts